/*
 * Authors: mariushirjanu
 * Created: 28/03/2024
 */
import * as _ from 'underscore';
import { Component, Input, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { IPaymentMatch } from './payment-matcher.service';
import { IPaymentMatchTransaction } from './payment-matcher-data.service';
import { util } from '@app/shared/util';

@Component({
  selector: 'payment-list-matches-amounts',
  template: `
    <div class="row margin-top-sm" *ngIf="!loading && (hasTotal || hasTotalWithBankCosts)">
      <div class="col-xxl-4 col-lg-6 col-md-11 col-sm-11 col-12 ms-auto">
        <table class="table table-bordered table-totals">
          <tr *ngIf="hasTotal">
            <th>Invoices matchable</th>
            <td>{{ amountTotal | format: 'formatNumber' }}</td>
            <td>&nbsp;</td>
            <th>Matched total</th>
            <td>{{ matchedAmountTotal | format: 'formatNumber' }}</td>
            <td class="ps-1 pe-1 text-center" [ngClass]="{ 'text-warning': amountTotal !== matchedAmountTotal, 'text-success': amountTotal === matchedAmountTotal }">
              <i *ngIf="amountTotal === matchedAmountTotal" class="fa fa-check-circle" title="OK - 'Matched total' is equal to 'Remaining invoice total'"></i>
              <i *ngIf="amountTotal !== matchedAmountTotal" class="fa fa-exclamation-circle" [ngClass]="{'text-danger': matchedAmountTotal > amountTotal }" title="NOK - 'Matched total' is different than 'Remaining invoice total'"></i>
            </td>
          </tr>
          <tr>
            <th>Transaction matchable</th>
            <td>{{ model?.totalWithBankCosts | format: 'formatNumber' }}</td>
            <td>&nbsp;</td>
            <th>Transaction remaining</th>
            <td>{{ (model?.totalWithBankCosts - matchedAmountTotal) | format: 'formatNumber' }}</td>
            <td class="ps-1 pe-1 text-center" [ngClass]="{ 'text-warning': matchedAmountTotal !== model.totalWithBankCosts, 'text-success': matchedAmountTotal === model.totalWithBankCosts }">
              <i *ngIf="matchedAmountTotal === model.totalWithBankCosts" class="fa fa-check-circle" title="OK - 'Transaction matchable total' is equal to 'Matched total'"></i>
              <i *ngIf="matchedAmountTotal !== model.totalWithBankCosts" class="fa fa-exclamation-circle" [ngClass]="{'text-danger': matchedAmountTotal > model.totalWithBankCosts }" title="NOK - 'Transaction matchable total' is different than 'Matched total'"></i>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <activity-indicator *ngIf="loading"></activity-indicator>
  `,
  styleUrls: ['./payment-matcher-dialog.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PaymentListMatchesAmountsComponent implements OnChanges {
  @Input() public model:IPaymentMatchTransaction;
  @Input() public loading:boolean;
  @Input() public rowData:IPaymentMatch[];
  public amountTotal:number;
  public matchedAmountTotal:number;

  public ngOnChanges(changes:SimpleChanges):void {
    if (changes.rowData) {
      this.rowData = changes.rowData.currentValue;
      this.calculateSumAmounts();
    }
  }

  private calculateSumAmounts():void {
    this.amountTotal = 0;
    this.matchedAmountTotal = 0;
    _.each(this.rowData, (paymentMatch:IPaymentMatch) => {
      this.amountTotal = this.amountTotal + (paymentMatch?.amount || 0);
      this.matchedAmountTotal = this.matchedAmountTotal + (paymentMatch.matchedAmount || 0);
    });
  }

  public get hasTotal():boolean {
    return util.notNullOrUndefined(this.amountTotal) || util.notNullOrUndefined(this.matchedAmountTotal);
  }

  public get hasTotalWithBankCosts():boolean {
    return util.notNullOrUndefined(this.model?.totalWithBankCosts);
  }
}